export const HOME_URL = '/';
export const COURSES_URL = '/tutorials';
export const SEARCH_URL = '/tutorials/search';
export const CATEGORIES_URL = '/tutorials/categories';
export const LIBRARY_URL = '/your-library';
export const SUGGESTION_URL = '/suggest-tutorials';
export const ABOUT_URL = '/about';
export const LOGIN_URL = '/login';
export const LOGOUT_URL = '/logout';
export const SIGNUP_URL = '/sign-up';
export const RESET_PASSWORD_URL = '/reset-password';
export const RESET_PASSWORD_DONE_URL = '/reset-password-done';
export const NO_FOUND_URL = '/no-found';

